<template>
  <button
    :type="nativeType"
    :disabled="disabled || loading"
    :class="{
      [`btn-${type}`]: true,
      'btn-block': block,
      'btn-lg': large && !small,
      'btn-sm': small && !large,
      'btn-loading': loading
    }"
    class="btn"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'VButton',
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    nativeType: {
      type: String,
      default: 'submit'
    },
    loading: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
